<template>
  <div class="container">
    <div class="list">
      <div class="item" @click="btnHandler('car')"  v-if="$processes.includes('car')">
        <div class="image" :style="{ background: $color }">
          <img src="../../assets/images/car/eap.pomoc-pomoc.na.drodze.svg" alt="">
        </div>
        <p class="text" :style="{ color: $color }">
          Pomoc na drodze
          <svg width="6" height="16" viewBox="0 0 6 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.247078 0.914727C0.51507 0.719824 0.89032 0.779075 1.08522 1.04707L5.88522 7.64707C6.03823 7.85746 6.03823 8.14248 5.88522 8.35287L1.08522 14.9529C0.89032 15.2209 0.51507 15.2801 0.247078 15.0852C-0.0209133 14.8903 -0.0801633 14.5151 0.11474 14.2471L4.65808 7.99997L0.11474 1.75287C-0.0801633 1.48488 -0.0209133 1.10963 0.247078 0.914727Z" :fill="$color"/>
          </svg>
        </p>
      </div>
      <div class="item" @click="btnHandler('home')" v-if="$processes.includes('home')">
        <div class="image" :style="{ background: $color }">
          <img src="../../assets/images/step_1_ico_1.svg" alt="">
        </div>
        <p class="text" :style="{ color: $color }">
          Pomoc w domu
          <svg width="6" height="16" viewBox="0 0 6 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.247078 0.914727C0.51507 0.719824 0.89032 0.779075 1.08522 1.04707L5.88522 7.64707C6.03823 7.85746 6.03823 8.14248 5.88522 8.35287L1.08522 14.9529C0.89032 15.2209 0.51507 15.2801 0.247078 15.0852C-0.0209133 14.8903 -0.0801633 14.5151 0.11474 14.2471L4.65808 7.99997L0.11474 1.75287C-0.0801633 1.48488 -0.0209133 1.10963 0.247078 0.914727Z" :fill="$color"/>
          </svg>
        </p>
      </div>
      <div class="item" @click="btnHandler('help')"  v-if="$processes.includes('med')">
        <div class="image" :style="{ background: $color }">
          <img src="../../assets/images/step_1_ico_2.svg" alt="">
        </div>
        <p class="text" :style="{ color: $color }">
          Pomoc medyczna
          <svg width="6" height="16" viewBox="0 0 6 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M0.247078 0.914727C0.51507 0.719824 0.89032 0.779075 1.08522 1.04707L5.88522 7.64707C6.03823 7.85746 6.03823 8.14248 5.88522 8.35287L1.08522 14.9529C0.89032 15.2209 0.51507 15.2801 0.247078 15.0852C-0.0209133 14.8903 -0.0801633 14.5151 0.11474 14.2471L4.65808 7.99997L0.11474 1.75287C-0.0801633 1.48488 -0.0209133 1.10963 0.247078 0.914727Z" :fill="$color"/>
          </svg>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
export default {
  name: "StepType",
  methods: {
    ...mapMutations(['setStep']),
    btnHandler (step) {
      this.$emit('setStep', step),
      this.setStep({ index: 0, step: { text: 'Weryfikacja', value: step }})
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/assistance_steps/StepType.vue